export default (index: number, length: number) => {
  return length - 1 === index;
};
